const state = {
  has_additional_children: null,
  is_question_1_yes: null,
  is_question_2_yes: null,
  living_in: null,
  hotel_name: null,
  shelter_name: null,
  shared_housing_start_date: null,
  watcher_type: null,
  name_of_watcher: null,
  address_of_watcher: null,
  email_of_watcher: null,
  phone_of_watcher: null,
}

const mutations = {
  setHasAdditionalChildren(state, value) {
    state.has_additional_children = value;
  },
  setIsQuestion1Yes(state, value) {
    state.is_question_1_yes = value;
  },
  setIsQuestion2Yes(state, value) {
    state.is_question_2_yes = value;
  },
  setLivingIn(state, value) {
    state.living_in = value;
  },
  setHotelName(state, value) {
    state.hotel_name = value;
  },
  setShelterName(state, value) {
    state.shelter_name = value;
  },
  setSharedHousingStartDate(state, value) {
    state.shared_housing_start_date = value;
  },
  setWatcherType(state, value) {
    state.watcher_type = value;
  },
  setWatcherName(state, value) {
    state.name_of_watcher = value;
  },
  setWatcherAddress(state, value) {
    state.address_of_watcher = value;
  },
  setWatcherEmail(state, value) {
    state.email_of_watcher = value;
  },
  setWatcherPhone(state, value) {
    state.phone_of_watcher = value;
  },
}

export default {
  namespaced: true,
  state,
  mutations
}
